import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment.dev';
import { Observable } from 'rxjs';
import { CheckoutPagesDTO, CreateCheckoutPayload } from '../types/api.types';

export interface CreateCheckoutSessionResponse {
  sessionUrl: string;
}

@Injectable({
  providedIn: 'root'
})
export class BackendService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  createCheckoutSession(data: CreateCheckoutPayload): Promise<CreateCheckoutSessionResponse> {
    return firstValueFrom(
      this.http.post<CreateCheckoutSessionResponse>(`${this.baseUrl}/stripe-checkout-session`, data)
    );
  }

  getLandingPage(id: string): Observable<CheckoutPagesDTO[]> {
    return this.http.get<CheckoutPagesDTO[]>(`${this.baseUrl}/landing-page/${id}`);
  }
}